/* Catalogue recherche Shop physique — BEM gas-shop-search-* */

.gas-shop-search {
    margin-block: var(--gas-space-6, 24px);
    padding: var(--gas-space-5, 20px);
    border: 1px solid var(--gas-border, #e5e7eb);
    border-radius: var(--gas-radius-lg, 12px);
    background: var(--gas-surface, #fff);
}

.gas-shop-search__title {
    margin: 0 0 var(--gas-space-3, 12px);
    font-size: var(--gas-font-size-lg, 18px);
    font-weight: 600;
    color: var(--gas-text, #111827);
}

.gas-shop-search__hint {
    margin: 0 0 var(--gas-space-4, 16px);
    color: var(--gas-text-muted, #6b7280);
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-shop-search__bar {
    display: flex;
    gap: var(--gas-space-2, 8px);
    align-items: stretch;
    margin-bottom: var(--gas-space-3, 12px);
}

.gas-shop-search__input {
    flex: 1 1 auto;
    min-width: 0;
    padding: 10px 14px;
    border: 1px solid var(--gas-border, #d1d5db);
    border-radius: var(--gas-radius-md, 8px);
    font-size: var(--gas-font-size-md, 16px);
    background: var(--gas-input-bg, #fff);
    color: var(--gas-text, #111827);
}

.gas-shop-search__input:focus {
    outline: 2px solid var(--gas-focus-ring, #2563eb);
    outline-offset: 1px;
}

.gas-shop-search__examples {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    margin-bottom: var(--gas-space-3, 12px);
}

.gas-shop-search__example {
    border: 1px dashed var(--gas-border, #d1d5db);
    background: transparent;
    color: var(--gas-text-muted, #6b7280);
    border-radius: 999px;
    padding: 4px 12px;
    font-size: var(--gas-font-size-sm, 14px);
    cursor: pointer;
}

.gas-shop-search__example:hover {
    color: var(--gas-text, #111827);
    border-color: var(--gas-primary, #2563eb);
}

.gas-shop-search__chips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    margin-bottom: var(--gas-space-3, 12px);
}

.gas-shop-search__chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px 4px 12px;
    border-radius: 999px;
    background: var(--gas-primary-soft, #eff6ff);
    color: var(--gas-primary, #1d4ed8);
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-shop-search__chip-remove {
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    padding: 0 2px;
}

.gas-shop-search__filters {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-3, 12px);
    margin-bottom: var(--gas-space-4, 16px);
    align-items: center;
}

.gas-shop-search__filter-label {
    font-size: var(--gas-font-size-sm, 14px);
    color: var(--gas-text-muted, #6b7280);
}

.gas-shop-search__filter-select,
.gas-shop-search__filter-input {
    padding: 6px 10px;
    border: 1px solid var(--gas-border, #d1d5db);
    border-radius: var(--gas-radius-md, 8px);
    font-size: var(--gas-font-size-sm, 14px);
    background: var(--gas-input-bg, #fff);
}

.gas-shop-search__status {
    margin: var(--gas-space-3, 12px) 0;
    color: var(--gas-text-muted, #6b7280);
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-shop-search__error {
    margin: var(--gas-space-3, 12px) 0;
}

.gas-shop-search__results {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: var(--gas-space-4, 16px);
    list-style: none;
    margin: 0;
    padding: 0;
}

.gas-shop-search__card {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--gas-border, #e5e7eb);
    border-radius: var(--gas-radius-lg, 12px);
    overflow: hidden;
    background: var(--gas-surface, #fff);
}

.gas-shop-search__card-media {
    aspect-ratio: 4 / 3;
    background: var(--gas-surface-muted, #f3f4f6);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.gas-shop-search__card-media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gas-shop-search__card-body {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2, 8px);
    padding: var(--gas-space-4, 16px);
    flex: 1 1 auto;
}

.gas-shop-search__card-title {
    margin: 0;
    font-size: var(--gas-font-size-md, 16px);
    font-weight: 600;
}

.gas-shop-search__card-title a {
    color: inherit;
    text-decoration: none;
}

.gas-shop-search__card-title a:hover {
    text-decoration: underline;
}

.gas-shop-search__card-meta {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    align-items: center;
}

.gas-shop-search__price {
    font-weight: 600;
    color: var(--gas-text, #111827);
}

.gas-shop-search__reason {
    font-size: var(--gas-font-size-sm, 14px);
    color: var(--gas-text-muted, #6b7280);
}

.gas-shop-search__options {
    font-size: var(--gas-font-size-sm, 14px);
    color: var(--gas-text, #374151);
}

.gas-shop-search__card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-2, 8px);
    margin-top: auto;
    padding-top: var(--gas-space-2, 8px);
}

.gas-shop-search__unavailable {
    font-size: var(--gas-font-size-sm, 14px);
    color: var(--gas-danger, #b91c1c);
}
